
export const setSessionButtonSizeForLanguage = (language: string) => {
    console.log('setSessionButtonSizeForLanguage called with language:', language);
    
    const buttonSizes = {
        'en': '90px',
        'ru': '110px', 
        'ua': '130px'
    };
    
    const size = buttonSizes[language as keyof typeof buttonSizes] || '90px';
    
    console.log('Applying button sizes for language', language, ':', { sessionButtonWidth: size });
    document.documentElement.style.setProperty('--sessionButtonWidth', size);
    console.log('CSS variable --sessionButtonWidth set to:', size);
    
    // Verify the value was actually set
    const actualValue = document.documentElement.style.getPropertyValue('--sessionButtonWidth');
    console.log('Verified CSS variable value:', actualValue);
};

export const getSessionButtonSizeForLanguage = (language: string): string => {
    const buttonSizes = {
        'en': '90px',
        'ru': '110px',
        'ua': '130px'
    };
    
    return buttonSizes[language as keyof typeof buttonSizes] || '90px';
};
